const e = up.element;
const u = up.util;
up.FragmentPolling = class FragmentPolling {
    static forFragment(fragment) {
        return fragment.upPolling || (fragment.upPolling = new this(fragment));
    }
    constructor(fragment) {
        this._options = up.radio.pollOptions(fragment);
        this._fragment = fragment;
        up.destructor(fragment, this._onFragmentDestroyed.bind(this));
        this._state = 'stopped';
        this._forceIntent = null;
        this._reloadJID = u.uid();
        this._loading = false;
        this._satisfyInterval();
    }
    onPollAttributeObserved() {
        this._start();
    }
    _onFragmentAborted({ newLayer, jid }) {
        const isOurAbort = (jid === this._reloadJID);
        if (isOurAbort || newLayer)
            return;
        this._stop();
    }
    _onFragmentKept() {
        if (this._forceIntent !== 'stop') {
            this._start();
        }
    }
    _onFragmentDestroyed() {
        this._stop();
    }
    _start(options) {
        Object.assign(this._options, options);
        if (this._state === 'stopped') {
            if (!up.fragment.isTargetable(this._fragment)) {
                up.warn('[up-poll]', 'Cannot poll untargetable fragment %o', this._fragment);
                return;
            }
            this._state = 'started';
            this._bindEvents();
            this._scheduleRemainingTime();
        }
    }
    _stop() {
        if (this._state === 'started') {
            this._clearReloadTimer();
            this._state = 'stopped';
        }
    }
    forceStart(options) {
        Object.assign(this._options, options);
        this._forceIntent = 'start';
        this._start();
    }
    forceStop() {
        this._forceIntent = 'stop';
        this._stop();
    }
    _bindEvents() {
        if (this._eventsBound)
            return;
        this._eventsBound = true;
        up.destructor(this._fragment, up.on('visibilitychange up:layer:opened up:layer:dismissed up:layer:accepted', this._onVisibilityChange.bind(this)));
        up.fragment.onAborted(this._fragment, this._onFragmentAborted.bind(this));
        up.fragment.onKept(this._fragment, this._onFragmentKept.bind(this));
    }
    _onVisibilityChange() {
        if (this._isFragmentVisible()) {
            this._scheduleRemainingTime();
        }
        else {
            this._clearReloadTimer();
        }
    }
    _isFragmentVisible() {
        return (!document.hidden) &&
            (this._options.ifLayer === 'any' || this._isOnFrontLayer());
    }
    _clearReloadTimer() {
        clearTimeout(this._reloadTimer);
        this._reloadTimer = null;
    }
    _scheduleRemainingTime() {
        if (this._reloadTimer || this._loading || this._state === 'stopped')
            return;
        this._clearReloadTimer();
        this._reloadTimer = setTimeout(this._onTimerReached.bind(this), this._getRemainingDelay());
    }
    _onTimerReached() {
        this._reloadTimer = null;
        this._tryReload();
    }
    _tryReload() {
        if (this._state === 'stopped') {
            return;
        }
        if (!up.fragment.isAlive(this._fragment)) {
            this._stop();
            up.puts('[up-poll]', 'Stopped polling a detached fragment');
            return;
        }
        if (!this._isFragmentVisible()) {
            up.puts('[up-poll]', 'Will not poll hidden fragment');
            return;
        }
        this._reloadNow();
    }
    _getFullDelay() {
        var _a, _b;
        return (_b = (_a = this._options.interval) !== null && _a !== void 0 ? _a : e.numberAttr(this._fragment, 'up-interval')) !== null && _b !== void 0 ? _b : up.radio.config.pollInterval;
    }
    _getRemainingDelay() {
        return Math.max(this._getFullDelay() - this._getFragmentAge(), 0);
    }
    _getFragmentAge() {
        return new Date() - this._lastAttempt;
    }
    _isOnFrontLayer() {
        var _a, _b;
        this.layer || (this.layer = up.layer.get(this._fragment));
        return (_b = (_a = this.layer) === null || _a === void 0 ? void 0 : _a.isFront) === null || _b === void 0 ? void 0 : _b.call(_a);
    }
    _reloadNow() {
        this._clearReloadTimer();
        this._loading = true;
        let guardEvent = up.event.build('up:fragment:poll', { log: ['Polling fragment', this._fragment] });
        let reloadOptions = Object.assign(Object.assign({}, this._options), { guardEvent, jid: this._reloadJID });
        up.reload(this._fragment, reloadOptions).then(this._onReloadSuccess.bind(this), this._onReloadFailure.bind(this));
    }
    _onReloadSuccess({ fragment }) {
        this._loading = false;
        this._satisfyInterval();
        if (fragment) {
            this._onFragmentSwapped(fragment);
        }
        else {
            this._scheduleRemainingTime();
        }
    }
    _onFragmentSwapped(newFragment) {
        if (this._forceIntent === 'start' && up.fragment.matches(this._fragment, newFragment)) {
            this.constructor.forFragment(newFragment).forceStart(this._options);
        }
    }
    _onReloadFailure(reason) {
        this._loading = false;
        this._satisfyInterval();
        this._scheduleRemainingTime();
        up.error.throwCritical(reason);
    }
    _satisfyInterval() {
        this._lastAttempt = new Date();
    }
};
